import banner1 from '/public/siteImages/iOSTheme/explore/theme1/banner1.png';
import footer1 from '/public/siteImages/iOSTheme/explore/theme1/footer1.png';
import header1 from '/public/siteImages/iOSTheme/explore/theme1/header1.png';
import mostViewed1 from '/public/siteImages/iOSTheme/explore/theme1/mostViewed1.png';
import popular1 from '/public/siteImages/iOSTheme/explore/theme1/popular1.png';
import recommend1 from '/public/siteImages/iOSTheme/explore/theme1/recommend1.png';

import banner2 from '/public/siteImages/iOSTheme/explore/theme2/banner2.png';
import footer2 from '/public/siteImages/iOSTheme/explore/theme2/footer2.png';
import header2 from '/public/siteImages/iOSTheme/explore/theme2/header2.png';
import mostViewed2 from '/public/siteImages/iOSTheme/explore/theme2/mostViewed2.png';
import popular2 from '/public/siteImages/iOSTheme/explore/theme2/popular2.png';
import recommend2 from '/public/siteImages/iOSTheme/explore/theme2/recommend2.png';

import banner3 from '/public/siteImages/iOSTheme/explore/theme3/banner3.png';
import footer3 from '/public/siteImages/iOSTheme/explore/theme3/footer3.png';
import header3 from '/public/siteImages/iOSTheme/explore/theme3/header3.png';
import mostViewed3 from '/public/siteImages/iOSTheme/explore/theme3/mostViewed3.png';
import popular3 from '/public/siteImages/iOSTheme/explore/theme3/popular3.png';
import recommend3 from '/public/siteImages/iOSTheme/explore/theme3/recommend3.png';

import banner4 from '/public/siteImages/iOSTheme/explore/theme4/banner4.png';
import footer4 from '/public/siteImages/iOSTheme/explore/theme4/footer4.png';
import header4 from '/public/siteImages/iOSTheme/explore/theme4/header4.png';
import mostViewed4 from '/public/siteImages/iOSTheme/explore/theme4/mostViewed4.png';
import popular4 from '/public/siteImages/iOSTheme/explore/theme4/popular4.png';
import recommend4 from '/public/siteImages/iOSTheme/explore/theme4/recommend4.png'


export {
    banner1,
    footer1,
    header1,
    mostViewed1,
    popular1,
    recommend1,
    banner2,
    footer2,
    header2,
    mostViewed2,
    popular2,
    recommend2,
    banner3,
    footer3,
    header3,
    mostViewed3,
    popular3,
    recommend3,
    banner4,
    footer4,
    header4,
    mostViewed4,
    popular4,
    recommend4
}
